module.exports = __webpack_public_path__ + "static/media/matilde-special-indiana-thinking.cda1897f.png";